// QRScanner.jsx
import React, { useEffect, useRef, useState } from 'react';
import QrScanner from 'qr-scanner';
import { Box, colors, Typography } from '@mui/material';
import { validate, version } from 'uuid'
import BASE_URL from '../../NetworkConfig/ApiConfig';


const QRScan = () => {
    const videoRef = useRef(null);
    const [result, setResult] = useState('');
    const qrScannerRef = useRef(null);
    const [scanning, setScanning] = useState(false)
    const [scannedCoupon, setScannedCoupon] = useState({})
    const [loadingDetails, setLoadingDetails] = useState(false)


    const isValidUUIDv4 = (id) => validate(id) && version(id) === 4;

    useEffect(() => {
        if (!videoRef.current) return;

        setScanning(true)

        qrScannerRef.current = new QrScanner(
            videoRef.current,
            (result) => {
                console.log('Scanned result:', result);

                if (isValidUUIDv4(result.data)) {
                    alert("Valid")
                    setResult(result.data);
                    setScanning(false)
                    qrScannerRef.current.stop(); // Stop scanning after success (optional)
                    getCouponDetails(result.data)
                } else {
                    alert("Not a valid qr")
                }

            },
            {
                highlightScanRegion: true,
                highlightCodeOutline: true,
                preferredCamera: 'environment',
            }
        );

        startScanner()

        return () => {
            qrScannerRef.current?.stop();
            setScanning(false)
        };
    }, []);


    function startScanner() {
        if (qrScannerRef.current) {
            qrScannerRef.current.start().catch((e) => {
                console.error('Camera start error:', e);
                alert('Camera access denied or not available.');
            });
        }
    }

    function markAsClaimed(couponCode) {

        try {

        } catch (error) {
            console.log(error)
        }

    }

    const getCouponDetails = async (couponCode) => {
        setLoadingDetails(true);
        const token = localStorage.getItem("token");
        const response = await fetch(`${BASE_URL}/user/get-coupon-details/${couponCode}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "auth-token": token,
            },
        });
        const data = await response.json();

        console.log(data)

        if (data.success === true) {
            setScannedCoupon(data.response)
        }else{
            alert(data.response)
        }

        setLoadingDetails(false)
    };

    return (
        <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
            <video ref={videoRef} style={{ width: '90%', background: "#aaaaaa10", border: "4px solid #ffffff20", borderRadius: "20px", aspectRatio: 1 / 1, objectFit: 'cover' }} />
            <p style={{ fontFamily: 'poppins-reg', marginTop: "30px" }} ><strong>Coupon Detail</strong></p>

            <Box sx={{
                background: "#171717", width: "90%", minHeight: "300px", borderRadius: "20px", paddingInline: "20px", paddingBlock: "20px",
                flexDirection: 'column', display: 'flex'
            }}>

                <Box sx={{
                    flexDirection: 'row', alignItems: 'center', justifyContent: 'center', display: 'flex', background: "#202020",
                    borderRadius: "15px", paddingInline: "15px", paddingBlock: "13px", marginBottom: "15px"
                }} >

                    <Box sx={{ width: "38px", height: "38px", borderRadius: 100, overflow: 'hidden', border: "2px solid #ffffff10" }}>
                        <img src={ scannedCoupon.rewardedUser ?  scannedCoupon.rewardedUser.image[0] : ""} style={{
                            width: "100%", height: "100%"
                        }} />
                    </Box>

                    <Box sx={{ flexDirection: 'column', display: 'flex', flex: 1, marginLeft: "15px" }}>
                        <Typography fontSize={"14px"} fontFamily={'poppins-reg'} color={"#ffffff"}>
                            {scannedCoupon.rewardedUser ? scannedCoupon.rewardedUser.full_name : ""}
                        </Typography>

                        <Typography fontSize={"11px"} fontFamily={'poppins-reg'} color={"#ffffff90"}>
                        {scannedCoupon.rewardedUser ? scannedCoupon.rewardedUser.buzz_name : ""}
                        </Typography>

                    </Box>


                    <Box sx={{width: "5px", height: "5px", marginRight: "5px", borderRadius: 100, background: scannedCoupon.rewardedUser ? scannedCoupon.rewardedUser.Active ? "green" : "grey" : "grey"}} />


                </Box>

                <Typography fontSize={"12px"} fontFamily={'poppins-reg'} color={"#ffffff90"}>
                    Coupon Code
                </Typography>

                <Box sx={{ flexDirection: 'row', alignItems: 'center', m: "3px 0 0 0", display: 'flex', marginBottom: "20px" }}>
                    <Typography
                        fontSize={"14px"}
                        color={colors.grey[100]}
                        fontFamily={"poppins-reg"}
                    >{scannedCoupon.code || ""}</Typography>

                </Box>

                <Box sx={{ flexDirection: 'row', alignItems: 'center', display: 'flex' }}>

                    <Box sx={{ flexDirection: 'column', display: 'flex', flex: 1 }}>
                        <Typography fontSize={"12px"} fontFamily={'poppins-reg'} color={"#ffffff90"}>
                            Reward Value
                        </Typography>

                        <Box sx={{ flexDirection: 'row', alignItems: 'center', m: "3px 0 0 0", display: 'flex' }}>
                            <Typography
                                fontSize={"14px"}
                                color={colors.grey[100]}
                                fontFamily={"poppins-reg"}
                            >{scannedCoupon.code ? `${scannedCoupon.rewardValue}` : "0"}</Typography>

                        </Box>
                    </Box>

                    <Box sx={{ flexDirection: 'column', display: 'flex', flex: 1 }}>
                        <Typography fontSize={"12px"} fontFamily={'poppins-reg'} color={"#ffffff90"}>
                            Reward Type
                        </Typography>

                        <Box sx={{ flexDirection: 'row', alignItems: 'center', m: "3px 0 0 0", display: 'flex' }}>
                            <Typography
                                fontSize={"14px"}
                                color={colors.grey[100]}
                                fontFamily={"poppins-reg"}
                            >{scannedCoupon.code ? `${scannedCoupon.rewardType}` : "none"}</Typography>


                        </Box>
                    </Box>

                </Box>


                <Box sx={{ flexDirection: 'row', alignItems: 'center', display: 'flex',  marginTop: "20px" }}>

                    <Box sx={{ flexDirection: 'column', display: 'flex', flex: 1 }}>
                        <Typography fontSize={"12px"} fontFamily={'poppins-reg'} color={"#ffffff90"}>
                            Scratched
                        </Typography>

                        <Box sx={{ flexDirection: 'row', alignItems: 'center', m: "3px 0 0 0", display: 'flex' }}>
                            <Typography
                                fontSize={"14px"}
                                color={colors.grey[100]}
                                fontFamily={"poppins-reg"}
                            >{scannedCoupon.code ? `${scannedCoupon.isScratched}` : "false"}</Typography>

                        </Box>
                    </Box>

                    <Box sx={{ flexDirection: 'column', display: 'flex', flex: 1 }}>
                        <Typography fontSize={"12px"} fontFamily={'poppins-reg'} color={"#ffffff90"}>
                            Claimed
                        </Typography>

                        <Box sx={{ flexDirection: 'row', alignItems: 'center', m: "3px 0 0 0", display: 'flex' }}>
                            <Typography
                                fontSize={"14px"}
                                color={colors.grey[100]}
                                fontFamily={"poppins-reg"}
                            >{scannedCoupon.code ? `${scannedCoupon.isClaimed}` : "false"}</Typography>


                        </Box>
                    </Box>

                </Box>

                <Box sx={{ flexDirection: 'row', alignItems: 'center', display: 'flex', marginTop: "20px" }}>

                    <Box sx={{ flexDirection: 'column', display: 'flex', flex: 1 }}>
                        <Typography fontSize={"12px"} fontFamily={'poppins-reg'} color={"#ffffff90"}>
                            Scratched At
                        </Typography>

                        <Box sx={{ flexDirection: 'row', alignItems: 'center', m: "3px 0 0 0", display: 'flex' }}>
                            <Typography
                                fontSize={"14px"}
                                color={colors.grey[100]}
                                fontFamily={"poppins-reg"}
                            >Jan 20, 2025</Typography>

                        </Box>
                    </Box>

                    <Box sx={{ flexDirection: 'column', display: 'flex', flex: 1 }}>
                        <Typography fontSize={"12px"} fontFamily={'poppins-reg'} color={"#ffffff90"}>
                            Claimed At
                        </Typography>

                        <Box sx={{ flexDirection: 'row', alignItems: 'center', m: "3px 0 0 0", display: 'flex' }}>
                            <Typography
                                fontSize={"14px"}
                                color={colors.grey[100]}
                                fontFamily={"poppins-reg"}
                            >Feb 02, 2025</Typography>


                        </Box>
                    </Box>




                </Box>
                <Box onClick={() => {
                    if (scannedCoupon.code) {
                        if (scannedCoupon.isClaimed) {
                            alert("Coupon is already claimed")
                        } else {
                            markAsClaimed(scannedCoupon.code)
                        }
                    } else {
                        alert("Coupon not found")
                    }
                }} sx={{
                    background: "#ffffff10", borderRadius: 100, alignItems: 'center', display: 'flex', justifyContent: 'center',
                    cursor: 'pointer',
                    paddingBlock: "15px", marginTop: "20px"
                }}>
                    <Typography style={{ fontFamily: 'poppins-reg', fontSize: "12px", color: "#ffffff" }} >Mark as Claimed</Typography>
                </Box>
            </Box>

        </div>
    );
};

export default QRScan;
